import { render, staticRenderFns } from "./PayRecord.vue?vue&type=template&id=3112fdde&scoped=true"
import script from "./PayRecord.vue?vue&type=script&lang=js"
export * from "./PayRecord.vue?vue&type=script&lang=js"
import style0 from "./PayRecord.vue?vue&type=style&index=0&id=3112fdde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112fdde",
  null
  
)

export default component.exports